import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import data from "../../../../assets/apiRoutes.json";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import {  ConsigneeCodesLayout, ConsigneeCRefrencesLayout } from "../../../common/Layouts";

function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const { userDefinedFormLookupsLoad } = props;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
       userDefinedFormLookupsLoad(formRefs)
    }, []);
    const handleRefrencesFormLoad = useCallback(() => {

    }, []);

    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (

        <TabPanel className="TabpanelContainer">
            <TabItem title="Codes">
                <FormField
                    currrentUser={currentUser}
                    layoutId='ECDA323C-268D-45DB-9E4F-F9A04498A96A'
                    layoutName='WMTransactionDataEntryUserDefinedTab'
                    defaultFormSchema={ConsigneeCodesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleCodesFormLoad}
                />
            </TabItem>
            <TabItem title="Refrences">
                <FormField
                    currrentUser={currentUser}
                    layoutId='AE442BFE-D7B0-4CF2-B70F-692FEF503DAE'
                    layoutName='WMTransactionDataEntryUserDefinedTab'
                    defaultFormSchema={ConsigneeCRefrencesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleRefrencesFormLoad}
                />
            </TabItem>
        </TabPanel>

    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
